import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _FlagIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1C6.70808 1 5.6887 1.17938 4.92329 1.4216C4.18729 1.65451 3.61805 1.96773 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3V22C3 22.5523 3.44772 23 4 23C4.55228 23 5 22.5523 5 22V15.5337C5.13381 15.469 5.30833 15.3975 5.52671 15.3284C6.07797 15.154 6.89192 15 8 15C9.28069 15 10.3605 15.4212 11.6286 15.9285L11.6843 15.9508C12.8931 16.4344 14.283 16.9906 15.9575 16.9999C16.6651 17.0523 17.5752 16.8465 18.313 16.6373C19.1141 16.4102 19.8957 16.1234 20.3792 15.9253C20.7547 15.7714 21 15.4058 21 15V3C21 2.61559 20.7797 2.26522 20.4332 2.0987C20.0867 1.93218 19.6755 1.979 19.3753 2.21913C19.0653 2.46712 18.5071 2.67878 17.8039 2.81942C17.1286 2.95448 16.4454 3 16 3C14.7193 3 13.6395 2.57876 12.3714 2.07152L12.3157 2.04923C11.0967 1.56148 9.69345 1 8 1ZM5 13.3978V3.53374C5.13381 3.46899 5.30833 3.39751 5.52671 3.3284C6.07797 3.15395 6.89192 3 8 3C9.28069 3 10.3605 3.42124 11.6286 3.92848L11.6843 3.95077C12.9033 4.43852 14.3066 5 16 5C16.5546 5 17.3714 4.94552 18.1961 4.78058C18.4534 4.72912 18.7258 4.66421 19 4.58132V14.313C18.6326 14.4462 18.2014 14.5901 17.7675 14.7131C17.0044 14.9295 16.3952 15.0324 16.0926 15.0043C16.0618 15.0014 16.0309 15 16 15C14.7193 15 13.6395 14.5788 12.3714 14.0715L12.3157 14.0492C11.0967 13.5615 9.69345 13 8 13C6.75077 13 5.75636 13.1677 5 13.3978Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const FlagIcon = assignWithoutSideEffects(_FlagIcon, {
  componentId: 'FlagIcon',
});

export default FlagIcon;
